import { emptyForm } from '../connectorConfig';
import { emptyArg } from '../connectorToolConfig';

// Ready shapes for common jobs. The host and the secret stay empty: the URL starts with https:///
// so the reader types the API's host there, and Auth is left for them to pick.
const arg = (name, description, required = true) => ({ ...emptyArg(), name, description, required });
const map = (pairs) => Object.entries(pairs).map(([key, value]) => ({ key, value }));

export const TEMPLATES = [
  {
    id: 'slots',
    kind: 'tool',
    label: 'Free slots',
    form: {
      url: 'https:///availability?city={{args.city}}&date={{args.date}}',
      root: 'data.items',
      mapRows: map({ place: 'venue.name', time: 'slot', price: 'price.amount' }),
      tool: {
        name: 'check_availability',
        description: 'Free appointment slots by city and date. Use when the shopper asks when they can book.',
        argRows: [
          arg('city', 'City name, for example Northtown'),
          arg('date', 'Day as YYYY-MM-DD; empty means the earliest', false),
        ],
        guidance: 'One row per slot. Show place, time and price.',
        notFoundText: 'Nothing free for these criteria.',
      },
    },
  },
  {
    id: 'stock',
    kind: 'tool',
    label: 'Stock by location',
    form: {
      url: 'https:///stock?item={{args.item_code}}&city={{args.city}}',
      root: 'locations',
      mapRows: map({ location: 'name', quantity: 'quantity' }),
      tool: {
        name: 'check_stock',
        description: 'Stock of an item by city. Use when the shopper asks where an item is available.',
        argRows: [arg('item_code', 'The item code shown on the product page'), arg('city', 'City name', false)],
        guidance: 'List the locations that have the item, with the quantity.',
        notFoundText: 'No stock found for this item.',
      },
    },
  },
  {
    id: 'hours',
    kind: 'tool',
    label: 'Opening hours',
    form: {
      url: 'https:///locations?city={{args.city}}',
      root: 'locations',
      mapRows: map({ name: 'name', address: 'address', hours: 'openingHours' }),
      tool: {
        name: 'opening_hours',
        description:
          'Addresses and opening hours of the locations in a city. Use when the shopper asks where or when to visit.',
        argRows: [arg('city', 'City name, for example Northtown')],
        guidance: 'One line per location: name, address, today’s hours.',
        notFoundText: 'No location in this city.',
      },
    },
  },
  {
    id: 'orders',
    kind: 'capability',
    label: 'Order lookup · orders.read',
    form: {
      capability: 'orders.read',
      url: 'https:///orders?email={{identity.email}}',
      root: 'orders',
      mapRows: map({ orderId: 'id', status: 'status', placedAt: 'created_at', total: 'total' }),
    },
  },
];

export const templatesFor = (kind) => TEMPLATES.filter((template) => template.kind === kind);

// A fresh form from the template; the secret and the host are left for the reader.
export const templateForm = (template) => {
  const blank = emptyForm();
  const { tool, ...rest } = template.form;
  return {
    ...blank,
    ...rest,
    mode: template.kind,
    tool: { ...blank.tool, ...tool },
  };
};
